export default {
  yourClips: 'Your clips'
}